import React from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Question from '../question/Question';

const Emailcard = ({ daten, cardcontent, handleUpdate, url, hovercolor }) => {
  const useStyles = makeStyles({
    ccsLabelFocused: {
      color: hovercolor + ' !important',
    },
    formLabelFocused: {
      color: hovercolor + ' !important',
    },
    cssFocused: {
      boxShadow: 'none',
      '& .MuiInput-input': {
        border: '1px ' + hovercolor + ' solid !important',
        borderBottom: '2px ' + hovercolor + ' solid !important',
        boxShadow: 'none',
      },
    },
    underline: {
      '&::after': {
        border: '1px solid ' + hovercolor + ' !important',
      },
    },
    formControl: {
      minWidth: 100,
    },
  });

  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;

  const handleChange = mailadress => {
    cardID in daten['info'] ? 0 : (daten['info'][cardID] = {}); //Create Dict in Info if not exists
    'mailadress' in daten['info'][cardID]
      ? 0
      : (daten['info'][cardID]['mailadress'] = {}); //Create Dict in Info if not exists

    daten['info'][cardID]['mailadress'] = mailadress;
    handleUpdate(daten);
  };

  const emailvalidierung = s => {
    var a = false;
    var res = false;
    if (typeof RegExp == 'function') {
      var b = new RegExp('abc');
      if (b.test('abc') == true) {
        a = true;
      }
    }
    if (a == true) {
      let reg = new RegExp(
        '^([a-zA-Z0-9-._]+)' + '(@)([a-zA-Z0-9-.]+)' + '(.)([a-zA-Z]{2,4})$'
      );
      res = reg.test(s);
    } else {
      res =
        s.search('@') >= 1 &&
        s.lastIndexOf('.') > s.search('@') &&
        s.lastIndexOf('.') >= s.length - 5;
    }
    return res;
  };
  const classes = useStyles();

  let renderObjekt = (
    <TextField
      InputProps={{
        style: {
          width: '190px',
          border:
            daten['info'][cardID]['mailadress']?.length == 0 ||
            (daten['info'][cardID]?.showerrors == 1 &&
              daten['info'][cardID]?.weiterButtonAllow == 0)
              ? '1px solid red'
              : '',
        },
        classes: {
          focused: classes.cssFocused,
          underline: classes.underline,
        },
      }}
      id="email"
      label="Ihre E-Mail-Adresse"
      type="email"
      value={
        daten['info'][cardID]['mailadress']
          ? daten['info'][cardID]['mailadress']
          : ''
      }
      InputLabelProps={{
        classes: {
          focused: classes.ccsLabelFocused,
        },
      }}
      onChange={e => {
        const mailadress = e.target.value;

        if (emailvalidierung(mailadress)) {
          daten['info'][cardID]['weiterButtonAllow'] = 1;
        } else {
          daten['info'][cardID]['weiterButtonAllow'] = 0;
        }
        handleChange(mailadress);
      }}
    ></TextField>
  );

  return (
    <div
      className="h-full flex flex-col justify-between items-center"
      id="emailcard"
    >
      <div className="text-center mt-20px">
        <Question questionNo={step} questionText={cardcontent['headline']} />
      </div>
      <div className="flex flex-col items-center">
        <img
          style={{
            maxWidth: '160px ',
            maxHeight: '100px ',
            minHeight: '100px ',
          }}
          src={process.env.PUBLIC_URL + 'iconinemailkarte.png'}
        ></img>
        <div className="p-2 text-center mb-10px">
          An welche E-Mail-Adresse möchten Sie die Wertermittlung erhalten?
        </div>
        <div className="text-center">{renderObjekt}</div>
        <div className="mt-10px p-2 text-center">
          Mit der Eintragung bestätigen Sie den Datenschutz & wir senden Ihnen
          die Wertermittlung per E-Mail zu.
        </div>
      </div>

      <div className="h-40px"></div>
    </div>
  );
};

export default Emailcard;
